import config from '../config/environment';
import { authService } from './auth';
import { apiCall } from './api'; // if apiCall is default-exported, adjust import accordingly

const API_URL = config.API_URL;

export const partyApi = {
  // List parties with search/pagination
  list: async ({ search = '', page = 1, pageSize = 20 } = {}) => {
    const qs = new URLSearchParams();
    if (search) qs.append('search', search);
    if (page) qs.append('page', page);
    if (pageSize) qs.append('pageSize', pageSize);
    return apiCall(`/Admin/Party${qs.toString() ? `?${qs}` : ''}`);
  },

  // Get by id
  getById: (id) => apiCall(`/Admin/Party/${id}`),

  // Create
  create: (data) =>
    apiCall('/Admin/Party', {
      method: 'POST',
      body: JSON.stringify({
        name: data.name?.trim(),
        shortName: data.shortName?.trim() || null,
        symbolUrl: data.symbolUrl || null
      })
    }),

  // Update
  update: (id, data) =>
    apiCall(`/Admin/Party/${id}`, {
      method: 'PUT',
      body: JSON.stringify({
        name: data.name?.trim(),
        shortName: data.shortName?.trim() || null,
        symbolUrl: data.symbolUrl || null
      })
    }),

  // Delete
  remove: (id) =>
    apiCall(`/Admin/Party/${id}`, { method: 'DELETE' }),

  // Upload Symbol (multipart)
  uploadSymbol: async (file) => {
    const token = authService.getToken();
    if (!file) throw new Error('No file selected');

    // 2MB limit
    if (file.size > 2 * 1024 * 1024) throw new Error('Symbol size must be less than 2MB');

    const allowed = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/svg+xml'];
    if (!allowed.includes(file.type)) throw new Error('Only PNG, JPG, JPEG, GIF, SVG allowed');

    const formData = new FormData();
    formData.append('file', file);

    const res = await fetch(`${API_URL}/Admin/Party/upload-symbol`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData
    });

    if (res.status === 401) {
      authService.logout();
      window.location.href = '/login';
      throw new Error('Unauthorized');
    }

    if (!res.ok) {
      const txt = await res.text();
      try {
        const j = JSON.parse(txt);
        throw new Error(j.message || j.error || 'Failed to upload symbol');
      } catch {
        throw new Error(txt || 'Failed to upload symbol');
      }
    }

    return res.json();
  }
};

export default partyApi;
